// extracted by mini-css-extract-plugin
export default {"container":"Stats_container__m6HLF","card":"Stats_card__VX1wG","label":"Stats_label__7LiFw","value":"Stats_value__ESPfY"};